import { OnboardingRouteRedirect } from '../../components';

export default function Step4TransactionsRedirect() {
  return <OnboardingRouteRedirect to="/(onboarding)/step-3-transactions" />;
}
